import _debounce from 'lodash/debounce';
import { isVisitorInChina, importGoogleMaps } from './_utils';
import themeRetroStyle from './embeddedMapTheme.json';

export default function initMap() {
	if (isVisitorInChina()) {
		$('.EmbeddedMap').hide();
		return;
	}

	const selectors = {
		mapApiKey: '.EmbeddedMap',
		map: '.EmbeddedMap-map',
		cta: '.EmbeddedMap-link',
	};
	const mapApiElements = $(selectors.mapApiKey);
	const mapElements = $(selectors.map);

	if (mapElements.length) {
		importGoogleMaps(mapApiElements.first().data('mapApikey')).then(Map => {
			mapElements.each(function (i, mapContainer) {
				const config = JSON.parse(mapContainer.dataset.map);
				const placeID = config.id;
				const center = {
					lat: parseFloat(config.lat),
					lng: parseFloat(config.lng),
				};
				const zoom = config.zoom.length > 0 ? parseFloat(config.zoom) : 16;
				const settings = {
					zoom: zoom,
					center: center,
					scrollwheel: false,
					mapTypeControl: false,
					fullscreenControl: false,
					streetViewControl: false,
					styles: themeRetroStyle,
					minZoom: 2,
				};
				const map = new Map(mapContainer, settings);

				map.addListener('idle', () => {
					checkBoundaries(map);
				});

				new google.maps.Marker({
					position: center,
					map: map,
					icon: {
						url: '/alt/fshr/design3/images/globalMapPin2x.png',
						scaledSize: { width: 20, height: 30 },
					},
				});

				if (placeID) {
					const cta = $(mapContainer).parent().find(selectors.cta);
					$(cta).attr('href', $(cta).attr('href') + '&query_place_id=' + placeID);
				}

				$(window).on(
					'resize',
					_debounce(function () {
						map.setCenter(center);
					}, 50)
				);
			});
		});
	}
}

/**
 * Check if the boundaries of the map are between the pole North and South latitude
 * and if they are outside, it centers the map to be inside those boundaries.
 * @param {google.maps.Map} map Google map object use for rendering
 */
function checkBoundaries(map) {
	const polesBoundary = 85; // Approximately the latitude where the poles are located. 85 for North and -85 for South
	const latNorth = map.getBounds().getNorthEast().lat();
	const latSouth = map.getBounds().getSouthWest().lat();
	const currentCenter = map.getCenter();
	let newCenterLat;
	let newCenter;

	if (latNorth >= polesBoundary) {
		newCenterLat = currentCenter.lat() - (latNorth - polesBoundary);
		newCenter = {
			lat: newCenterLat,
			lng: currentCenter.lng(),
		};
		map.setCenter(newCenter);
	} else if (latSouth <= -polesBoundary) {
		newCenterLat = currentCenter.lat() + Math.abs(latSouth + polesBoundary);
		newCenter = {
			lat: newCenterLat,
			lng: currentCenter.lng(),
		};
		map.setCenter(newCenter);
	}
}
